<template>
  <div class="section" style="padding: 13px 20px 10px 20px">
    <el-form :disabled="!isEdit" :inline="true" :label-width="isZh?'80px':'120px'" label-position="left">
      <el-form-item :label="$t('SeaExport.Oversea')">
        <el-select v-model="form.oversea" no="oversea" clearable>
          <el-option :label="$t('SeaExport.internal')" value="internal" />
          <el-option :label="$t('SeaExport.overseas')" value="oversea" />
        </el-select>
      </el-form-item>
    </el-form>
    <el-form :disabled="!isEdit" :inline="true" :label-width="isZh?'80px':'140px'" label-position="left">
      <el-form-item :label="$t('CargoMsg.Cargo_CurrencyRequirements')" style="display: flex">
        <el-radio-group v-model="form.currencyRequirements" no="currencyRequirements">
          <el-radio no="notSpecified" :label="1" style="margin-right:10px">{{ $t('CargoMsg.Cargo_NotSpecified') }}</el-radio>
          <el-radio no="appoint" :label="2">{{ $t('CargoMsg.Cargo_Appoint') }}</el-radio>
          <el-select v-model="form.appointCurrency" no="appointCurrency" clearable style="width: 100px" filterable>
            <el-option v-for="(item,index) in currencyList" :key="index" :label="item.label" :value="item.code" />
          </el-select>
          <el-radio no="originalCurrency" :label="3" style="padding-left:20px">{{ $t('CargoMsg.Cargo_PaymentInOriginalCurrency') }} </el-radio>
        </el-radio-group>
        <span
          style="padding-left: 30px"
        >
          <svg-icon slot="reference" icon-class="question" style="font-size: 14px;margin-top: -3px;" />
        </span>
        <span style="color: red">{{ $t('Message.CreateBill') }}</span>
      </el-form-item>
    </el-form>
    <el-form :disabled="!isEdit" :inline="true" :label-width="isZh?'80px':'120px'" label-position="left">
      <el-form-item :label="$t('Payment.invoicingMethod')">
        <el-radio-group v-model="form.invoiceMode" no="invoiceMode">
          <el-radio no="invoicingPerBill" :label="0" style="margin-right:10px">{{ $t('Partners.invoicingPerBill') }}</el-radio>
          <el-radio no="invoicingPerMonth" :label="1">{{ $t('Partners.invoicingPerMonth') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item class="custom">
        <el-checkbox v-model="form.overInvoicing" no="overInvoicing">{{ $t('Partners.canOverPrice') }}</el-checkbox>
      </el-form-item>
    </el-form>
    <el-form :disabled="!isEdit" :inline="true" :label-width="isZh?'80px':'120px'" label-position="left">
      <el-form-item :label="$t('Payment.sellerInvoiceTitle')" class="custom">
        <cargo-advance-select
          :filterable="true"
          filter-type="global"
          :filter-tag-names="['invoiceTitle']"
          :default-value="form.sellerTaxAccount"
          :static-options="sellerInvoiceTitleOptions"
          :cache="false"
          tag-name="invoiceTitle"
          tag-value="taxAccount"
          style="width: 300px"
          :disabled="!isEdit"
          @parentCallBack="handleSellerInvoiceTitleChange"
        />
      </el-form-item>
    </el-form>
    <el-form :disabled="!isEdit" :inline="true" :label-width="isZh?'80px':'120px'" label-position="left">
      <el-form-item :label="$t('Partners.invoicingNote')" class="custom">
        <el-input v-model="form.invoiceRemarks" no="invoiceRemarks" type="textarea" :rows="5" style="width:500px" />
      </el-form-item>
    </el-form>
    <!-- 税率-发票类型配置列表 -->
    <span class="title">{{ isZh ? '税率-发票类型配置' : 'Tax Rate - Invoice Type Config' }}</span>
    <div class="grid-view">
      <div class="main-content">
        <div class="operations" style="margin-top: 5px;margin-bottom: 5px">
          <div class="triggers">
            <div>
              <el-button :disabled="!isEdit" type="primary" size="small" @click="showTaxInvoiceDialog(true)">{{ $t('common.btn.new') }}</el-button>
              <el-button :disabled="!isEdit" type="primary" size="small" @click="showTaxInvoiceDialog(false)">{{ $t('common.btn.edit') }}</el-button>
              <el-button :disabled="!isEdit" type="danger" size="small" @click="removeTaxInvoice">{{ $t('common.btn.delete') }}</el-button>
            </div>
          </div>
        </div>
        <div class="grid-wrapper">
          <el-table
            :data="taxInvoiceList"
            border
            size="mini"
            height="200"
            highlight-current-row
            @current-change="row => taxInvoiceCurrentRow = row"
          >
            <el-table-column
              :label="$t('Partners.taxRate')"
              prop="taxRate"
              width="300"
            >
              <template slot-scope="scope">
                {{ getTaxRateLabel(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('CargoMsg.Cargo_InvoiceType')"
              prop="invoiceType"
            >
              <template slot-scope="scope">
                {{ getInvoiceTypeLabel(scope.row) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 税率-发票类型 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="taxInvoiceEditDialog.visible"
      :title="taxInvoiceEditDialog.title"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form label-width="100px" label-position="left">
        <el-form-item :label="$t('Partners.taxRate')" required>
          <el-select v-model="taxInvoiceEditDialog.form.taxRate" no="taxRate" style="width: 100%" @change="taxRateChangeHandler">
            <el-option
              v-for="(item, index) in taxRateOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_InvoiceType')" required>
          <el-select v-model="taxInvoiceEditDialog.form.invoiceType" no="invoiceType" style="width: 100%" @change="invoiceTypeChangeHandler">
            <el-option
              v-for="(item, index) in taxInvoiceTypeOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button no="save" type="primary" @click="saveTaxInvoice">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="taxInvoiceEditDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <span class="title">{{ $t('CargoMsg.Cargo_InvoicingInformation') + $t('CargoMsg.Cargo_list') }}</span>
    <div class=" grid-view">
      <div class="main-content">
        <div class="operations" style="margin-top: 5px;margin-bottom: 5px">
          <div class="triggers">
            <div>
              <el-button
                v-if="!this.showIfRisk"
                no="new"
                :disabled="!isEdit"
                type="primary"
                @click="showEditDialog(true)"
              >{{ $t('common.btn.new') }}</el-button>
              <el-button
                no="edit"
                :disabled="!isEdit"
                type="primary"
                @click="showEditDialog(false)"
              >{{ $t('common.btn.edit') }}</el-button>
              <el-button v-if="!this.showIfRisk" :disabled="!isEdit" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
              <el-button v-if="jydToFinanceApi" :disabled="isEdit" type="primary" @click="pushAddCustomer">{{ $t('CargoMsg.Cargo_PushAddCustomer') }}</el-button>
            </div>
          </div></div>
        <div class="grid-wrapper">
          <cargo-ag-grid
            config-module="101404"
            :grid-params.sync="girdParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
      </div>
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="$t('CargoMsg.Cargo_InvoicingInformation')"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="145px" label-position="left">
          <el-form-item v-if="jydToFinanceApi && editDialog.form.uuid" :label="$t('CargoMsg.Cargo_CustomerCode')">
            <el-input v-model="editDialog.form.financeCode" no="financeCode" @blur="deleteTrim('financeCode')" />
          </el-form-item>
          <el-form-item :label="$t('Payment.invoiceHeader')">
            <el-input v-model="editDialog.form.title" no="title" :disabled="oujianEditLimit" @blur="deleteTrim('title')" />
          </el-form-item>
          <el-form-item :label="$t('Partners.registrationNumber')">
            <el-input v-model="editDialog.form.taxAccount" no="taxAccount" :disabled="oujianEditLimit" />
          </el-form-item>
          <el-form-item :label="$t('Partners.invoiceAddress')">
            <el-input v-model="editDialog.form.address" no="address" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Tel')">
            <el-input v-model="editDialog.form.telephone" no="telephone" />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_DepositBankAndAccountNo')">
            <cargo-rich-textarea ref="depositBankAccount" v-model="editDialog.form.depositBankAccount" no="depositBankAccount" :text-chars="0" :warning-count="-1" style="min-height: 90px;" />
          </el-form-item>
          <el-form-item :label="$t('Invoice.invoice_invoiceCategory')">
            <el-select v-model="editDialog.form.invoiceMakeType" no="invoiceMakeType" clearable @change="invoiceMakeTypeChangeHandler">
              <el-option v-for="(item,index) in invoiceMakeTypes" :key="index" :label="isZh?item.chineseName:item.englishName" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_InvoiceType')">
            <el-select v-model="editDialog.form.invoiceType" no="invoiceType" clearable>
              <el-option v-for="(item,index) in invoiceTypes" :key="index" :label="isZh?item.chineseName:item.englishName" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('Partners.CustomerMailbox')">
            <el-input v-model="editDialog.form.email" no="email" />
          </el-form-item>
          <el-form-item :label="$t('Partners.isDefault')">
            <el-radio-group v-model="editDialog.form.defaultTitle" no="defaultTitle" @change="onDefaultChange">
              <el-radio no="yes" :label="true">{{ $t('Message.Yes') }}</el-radio>
              <el-radio no="no" :label="false">{{ $t('Message.No') }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <span slot="label" style="display: flex">
              {{ $t('Partners.autoEmailSettings') }}
              <el-tooltip effect="light" :content="$t('Partners.partnerInvoiceReminder')" placement="bottom-start">
                <img :src="iconQuestion" width="15" height="15" style="cursor:pointer;padding-top: 2px;padding-right: 2px;">
              </el-tooltip>
            </span>
          </el-form-item>
          <el-form-item>
            <span slot="label" style="display: flex;">
              {{ $t('Partners.taxControlPlatformSending') }}
              <el-checkbox v-model="editDialog.form.platformAutoSend" no="platformAutoSend" style="margin-left: 10px" />
            </span>
            <cargo-advance-select
              v-show="editDialog.form.platformAutoSend"
              no="platformEmailSendTo"
              :static-options="emailSendObjs"
              tag-value="code"
              :clearable="false"
              :default-value="editDialog.form.platformEmailSendTo"
              @parentCallBack="p=>{editDialog.form.platformEmailSendTo=p.value}"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label" style="display: flex;">
              {{ $t('Partners.systemAutomaticSending') }}
              <el-checkbox v-model="editDialog.form.autoSend" no="autoSend" style="margin-left: 10px" />
            </span>
            <cargo-advance-select
              v-show="editDialog.form.autoSend"
              no="defaultEmailSendTo"
              :static-options="emailSendObjs"
              tag-value="code"
              :clearable="false"
              :default-value="editDialog.form.defaultEmailSendTo"
              @parentCallBack="p=>{editDialog.form.defaultEmailSendTo=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Oversea')">
            <el-select v-model="editDialog.form.oversea" no="oversea" clearable>
              <el-option :label="$t('SeaExport.internal')" value="internal" />
              <el-option :label="$t('SeaExport.overseas')" value="oversea" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <span slot="label" style="display: flex;">
              {{ $t('Information.ApplicableWhtTax') }}
              <el-tooltip :content="$t('Information.ApplicableWhtTaxTip')" placement="right">
                <svg-icon icon-class="question" style="font-size: 16px;" />
              </el-tooltip>
              <el-checkbox v-model="editDialog.form.suitWhtTax" no="suitWhtTax" style="margin-left: 10px" />
            </span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_InvoicingRequirements')">
            <el-input ref="invoiceDemand" v-model="editDialog.form.invoiceDemand" no="invoiceDemand" type="textarea" :maxlength="256" :rows="5" :clearable="true" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="saveTemporary">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 银行维护弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="bankDialog.visible"
      :title="$t('Partners.bankOfInvoiceHeader')"
      width="800px"
      :close-on-click-modal="false"
    >
      <title-bank-form
        ref="titleBankForm"
        :title="bankDialog.title"
        :show-if-risk="showIfRisk"
      />
    </el-dialog>
    <!-- 推送新增客商弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="pushAddCustomerDialog.visible"
      :title="$t('CargoMsg.Cargo_PushAddCustomer')"
      width="350px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding: 20px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('CargoMsg.Cargo_ChooseArea')">
            <el-select v-model="pushAddCustomerDialog.areaCode" no="areaCode" @change="invoiceMakeTypeChangeHandler">
              <el-option v-for="(item,index) in SystemConstants.U8C_AREAS" :key="index" :label="isZh?item.chineseName:item.englishName" :value="item.code" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="confirm" type="primary" @click="confirmPush">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="cancel" @click="pushAddCustomerDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import iconQuestion from '@/assets/icon-question.png'
import titleBankForm from './titleBankForm'
import { getTitleList, syncTitleToYYU8 } from '@/api/partner/title'
import { getTitleBankList } from '@/api/partner/titleBank'
import { DocumentManage, AutoIncrementNum } from '@/utils/commonUtil'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { TabError } from '@/utils/class/TabError'
import { cache, cacheName } from '@/utils/cacheManager'
import LocalStorageUtils from '@/utils/localStorageUtils'
import * as CompanyConstants from '@/class/cargo/model/parameters/CompanyConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { getGridSelected } from '@/utils/agGrid'
import { syncInvoiceToYYU8 } from '@/api/clearing/invoice'
import { getInvoiceTitlesByOffice } from '@/api/sysManage/officeInvoiceTitle'
import { loadCompanyRelated } from '@/api/company'

export default {
  name: 'TitleForm',
  components: { titleBankForm, CargoAdvanceSelect, cargoRichTextarea },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      SystemConstants,
      emailSendObjs: CompanyConstants.EMAIL_SEND_OBJS,
      iconQuestion,
      currencyList: [],
      form: {
        sellerTaxAccount: '',
        sellerInvoiceTitle: ''
      },
      filter: {
        customerUuid: '',
        pageNum: 1,
        pageSize: 100000
      },
      girdParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      rowData: [],
      deletedTitleKeys: [],
      editDialog: {
        visible: false,
        title: '',
        initialForm: null,
        form: {
          uuid: '',
          title: '',
          taxAccount: '',
          address: '',
          telephone: '',
          defaultTitle: true,
          email: '',
          autoSend: true,
          customerUuid: '',
          invoiceType: '',
          invoiceMakeType: '',
          defaultEmailSendTo: 2,
          oversea: '',
          depositBankAccount: '',
          platformAutoSend: true,
          platformEmailSendTo: 2,
          suitWhtTax: false,
          financeCode: '',
          invoiceDemand: ''
        }
      },
      bankDialog: {
        visible: false,
        title: {}
      },
      documentManage: new DocumentManage(),
      autoIncrementNum: new AutoIncrementNum(),
      invoiceTypes: InvoiceConstant.BILLING_INVOICE_TYPES,
      jydToFinanceApi: false,
      pushAddCustomerDialog: {
        visible: false,
        areaCode: ''
      },
      showIfRisk: false,
      sellerInvoiceTitleOptions: [],
      // 税率-发票类型配置
      taxInvoiceList: [],
      deletedTaxInvoiceKeys: [],
      taxInvoiceCurrentRow: null,
      taxInvoiceEditDialog: {
        visible: false,
        title: '',
        initialForm: { uuid: '', taxRate: '', taxRateName: '', invoiceType: '', invoiceTypeName: '' },
        form: { uuid: '', taxRate: '', taxRateName: '', invoiceType: '', invoiceTypeName: '' }
      }
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    gridApi() {
      return this.girdParams.api
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    },
    bankDialogVisible() {
      return this.bankDialog.visible
    },
    invoiceMakeTypes() { // 内部发票只有纸质，没有电子
      if (this.editDialog.form.invoiceType === InvoiceConstant.BILLING_INVOICE_TYPE_INTERNAL.code) {
        return [InvoiceConstant.BILLING_INVOICE_CATEGORY_PAPER_INVOICE]
      } else {
        return InvoiceConstant.BILLING_INVOICE_CATEGORY
      }
    },
    // 税率选项
    taxRateOptions() {
      return [
        { value: '0', label: this.isZh ? '免税' : 'Tax-free' },
        { value: '6', label: '6%' },
        { value: '9', label: '9%' }
      ]
    },
    // 发票类型选项（全电，code为数字字符串）
    taxInvoiceTypeOptions() {
      return InvoiceConstant.INVOICE_TYPES_FEI.map(item => ({
        value: String(item.code),
        label: this.isZh ? item.chineseName : item.englishName
      }))
    },
    columnDefs() {
      return [
        {
          headerName: this.$t('CargoMsg.Cargo_CustomerCode'),
          field: 'financeCode',
          initialHide: !this.jydToFinanceApi,
          suppressColumnsToolPanel: !this.jydToFinanceApi,
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FinancialCode'),
          field: 'titleId',
          hide: true,
          width: 110
        },
        {
          headerName: this.$t('Payment.invoiceHeader'),
          field: 'title',
          width: 110
        },
        {
          headerName: this.$t('Partners.registrationNumber'),
          field: 'taxAccount',
          width: 150
        },
        {
          headerName: this.$t('Partners.invoiceAddress'),
          field: 'address',
          width: 200
        },
        {
          headerName: this.$t('SeaExport.Tel'),
          field: 'telephone',
          width: 150
        },
        {
          headerName: this.$t('Partners.isDefault'),
          field: 'defaultTitle',
          width: 110,
          cellRenderer: params => {
            return params.value ? '√' : ''
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DepositBankAndAccountNo'),
          field: 'depositBankAccount',
          width: 150
        },
        {
          headerName: this.$t('Partners.bankOfInvoiceHeader'),
          field: 'bank',
          width: 150,
          valueFormatter: params => {
            const data = params.data
            if (data.bankList.length > 0) {
              return Array.from(data.bankList, p => p.currency + ':' + p.bank + ':' + p.bankAccount).reduce((a, b) => a + '\n' + b)
            } else {
              return ''
            }
          }
        },
        {
          headerName: this.$t('Partners.CustomerMailbox'),
          field: 'email',
          width: 150
        },
        {
          headerName: this.$t('Partners.systemAutomaticSending'),
          field: 'autoSend',
          width: 195,
          valueFormatter: params => {
            return params.value ? this.$t('Message.Yes') : this.$t('Message.No')
          }
        },
        {
          headerName: this.$t('Partners.systemAutomaticSendingObject'),
          field: 'defaultEmailSendTo',
          width: 140,
          valueFormatter: params => {
            if (!params.data.autoSend) {
              return ''
            }
            return this.emailSendToLabel(params.value)
          }
        },
        {
          headerName: this.$t('Partners.taxControlPlatformSending'),
          field: 'platformAutoSend',
          width: 195,
          valueFormatter: params => {
            return params.value ? this.$t('Message.Yes') : this.$t('Message.No')
          }
        },
        {
          headerName: this.$t('Partners.taxControlPlatformSendingObject'),
          field: 'platformEmailSendTo',
          width: 140,
          valueFormatter: params => {
            if (!params.data.platformAutoSend) {
              return ''
            }
            return this.emailSendToLabel(params.value)
          }
        },
        {
          headerName: this.$t('FileHistory.operation'),
          width: 100,
          cellRenderer: params => {
            if (this.isEdit) {
              const methodPath = this.documentManage.getPath('bankManage')
              return `<u onclick="${methodPath}(${params.data.seq})" style="color:blue;cursor:pointer">${this.$t('Partners.bankMaintenance')}</u>`
            } else {
              return `<u style="color:blue">${this.$t('Partners.bankMaintenance')}</u>`
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvoiceType'), field: 'invoiceType', colId: 'invoiceType', width: 120
        },
        {
          headerName: this.$t('Invoice.invoice_invoiceCategory'), field: 'invoiceMakeType', colId: 'invoiceMakeType', width: 120
        },
        {
          headerName: this.$t('SeaExport.Oversea'),
          field: 'oversea',
          width: 100,
          valueFormatter: params => {
            switch (params.value) {
              case 'internal':
                return this.$t('SeaExport.internal')
              case 'oversea':
                return this.$t('SeaExport.overseas')
              default:
                return ''
            }
          }
        },
        {
          headerName: this.$t('Information.ApplicableWhtTax'),
          field: 'suitWhtTax',
          width: 100,
          valueFormatter: params => {
            return params.value ? this.$t('Message.Yes') : this.$t('Message.No')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvoicingRequirements'),
          field: 'invoiceDemand',
          width: 100
        }
      ]
    },
    // CARGO-45565 客商数据CargoWare读取欧坚数据库 判断是否是编辑状态，如果是编辑状态，就隐藏
    oujianEditLimit() {
      return this.action === 'edit' && this.showIfRisk
    }
  },
  watch: {
    isEdit(newVal) {
      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData)
      }
    },
    bankDialogVisible(newVal) {
      if (!newVal) {
        this.gridApi.refreshCells({ force: true })
        this.gridApi.resetRowHeights()
      }
    }
  },
  async created() {
    // initialForm 不依赖配置缓存，同步赋值提前：lazy 页签首次激活时 onShow 可能早于下方 await 完成执行，
    // initialForm 为 null 会导致 onShow 中途 TypeError 中断、税率-发票类型配置列表无法赋值（首次进入空白）
    this.editDialog.initialForm = this.editDialog.form
    await cache.load(cacheName.CONFIG)
    this.jydToFinanceApi = cache.config.get('ToFinanceApi') === 'JYDYY' // 集翊达用友U8CLOUD
    this.showIfRisk = (Number(cache.config.get('oujianPartner')) === 1) // CARGO-45565【欧坚客户化】数据库抓起限制“合作伙伴”
    await this.loadSellerInvoiceTitleOptions()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('bankManage', function(uuid) {
      context.bankManage(uuid)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    // 删除空格
    deleteTrim(name) {
      this.editDialog.form[name] = this.editDialog.form[name] ? this.editDialog.form[name].trim() : ''
    },
    handleSellerInvoiceTitleChange(p) {
      const value = p ? (p.value || p.tagValue || '') : ''
      this.form = this.form || {}
      this.form.sellerTaxAccount = value
      this.ensureSellerInvoiceTitleField()
    },
    ensureSellerInvoiceTitleField() {
      this.form = this.form || { sellerTaxAccount: '', sellerInvoiceTitle: '' }
      const sellerTaxAccount = this.form.sellerTaxAccount || ''
      if (!sellerTaxAccount) {
        this.form.sellerInvoiceTitle = ''
        return
      }
      const match = (this.sellerInvoiceTitleOptions || []).find(item => item && item.taxAccount === sellerTaxAccount)
      this.form.sellerInvoiceTitle = match ? (match.invoiceTitle || '') : ''
    },
    async loadSellerInvoiceTitleOptions() {
      try {
        const res = await getInvoiceTitlesByOffice({ officeId: this.$store.getters.currentOfficeId })
        const list = Array.isArray(res.data) ? res.data : []
        this.sellerInvoiceTitleOptions = list
        this.ensureSellerInvoiceTitleField()
      } catch (error) {
        // ignore load error
      }
    },
    onShow(row, isRefresh) {
      if (isRefresh) {
        // 税率-发票类型配置列表最优先赋值：页签一进入立即展示，后续任何初始化异常都不影响它
        const raw = Array.isArray(row.taxInvoiceList) ? row.taxInvoiceList : []
        this.taxInvoiceList = raw.map(item => ({
          ...item,
          seq: this.autoIncrementNum.getNextNum(),
          taxRate: item.taxRate != null ? String(item.taxRate) : '',
          invoiceType: item.invoiceType != null ? String(item.invoiceType) : ''
        }))
        this.deletedTaxInvoiceKeys = []
        this.taxInvoiceCurrentRow = null
        // 兜底：快照缺配置时按公司 uuid 直接拉接口展示（与父组件数据链路解耦）
        if (raw.length === 0 && row.uuid) {
          this.fetchTaxInvoiceList(row.uuid)
        }
        // 其余初始化异常隔离：历史上 initialForm 为 null 的 TypeError 会中断整个 onShow 导致列表空白
        try {
          this.form = row.customerDetail
          this.ensureSellerInvoiceTitleField()
          this.filter.customerUuid = row.customerDetail.uuid
          this.toQuery()
          this.deletedTitleKeys = []
          if (!this.editDialog.initialForm) {
            this.editDialog.initialForm = this.editDialog.form
          }
          this.editDialog.initialForm.customerUuid = this.form.uuid
        } catch (e) {
          console.error('[TitleForm] onShow 初始化异常（不影响配置列表展示）', e)
        }
      }
    },
    // 兜底：按公司 uuid 直接拉取税率-发票类型配置（父组件快照缺数据时使用，仅在当前无数据时填充）
    async fetchTaxInvoiceList(companyUuid) {
      try {
        const res = await loadCompanyRelated({ companyUuid: companyUuid, taxInvoiceList: true })
        const data = res && res.data ? res.data : {}
        const list = Array.isArray(data.taxInvoiceList) ? data.taxInvoiceList : []
        if (list.length > 0 && this.taxInvoiceList.length === 0) {
          this.taxInvoiceList = list.map(item => ({
            ...item,
            seq: this.autoIncrementNum.getNextNum(),
            taxRate: item.taxRate != null ? String(item.taxRate) : '',
            invoiceType: item.invoiceType != null ? String(item.invoiceType) : ''
          }))
        }
      } catch (e) {
        console.error('[TitleForm] 税率-发票类型配置兜底加载失败', e)
      }
    },
    async getSubmitData() {
      await this.validateForm(this.form)
      return {
        customerDetail: this.form,
        titles: this.rowData,
        deletedTitleKeys: this.deletedTitleKeys,
        taxInvoiceList: this.taxInvoiceList,
        deletedTaxInvoiceKeys: this.deletedTaxInvoiceKeys
      }
    },
    async validateForm(form) {
      if (form && this.form.currencyRequirements <= 0 && Number(cache.config.get('PartnerInvoiceCurrencyRequirementSelected'))) {
        throw new TabError(this.$t('CargoMsg.Cargo_PleaseInvoicingRequirementsTab'), 'titleForm')
      }
    },
    async toQuery() {
      // 加载币种信息
      this.currencyList = await getSpecificBasicData(TYPE_NAMES.basic_data_Currency)
      const filter = this.filter
      if (!filter.customerUuid) {
        this.rowData = []
        return
      }
      const data = await getTitleList(filter).then(res => res.data.list)
      if (data.length > 0) {
        const ajaxResults = []
        const titleMap = new Map()
        let titleUuidList = []
        for (const item of data) {
          item.bankList = []
          item.seq = this.autoIncrementNum.getNextNum()
          titleMap.set(item.uuid, item)
          titleUuidList.push(item.uuid)
          if (titleUuidList.length >= 100) {
            ajaxResults.push(getTitleBankList({ titleUuidList: titleUuidList }))
            titleUuidList = []
          }
        }
        if (titleUuidList.length > 0) {
          ajaxResults.push(getTitleBankList({ titleUuidList: titleUuidList }))
        }
        await Promise.all(ajaxResults).then(results => {
          const data = []
          for (const result of results) {
            data.push(...result.data)
          }
          data.forEach(item => {
            item.seq = this.autoIncrementNum.getNextNum()
            const title = titleMap.get(item.titleUuid)
            title.bankList.push(item)
          })
        })
      }
      // 按最后修改时间倒序排序
      data.sort((a, b) => {
        const timeA = a.dateModified ? new Date(a.dateModified).getTime() : 0
        const timeB = b.dateModified ? new Date(b.dateModified).getTime() : 0
        return timeB - timeA
      })
      this.rowData = data
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = { ...this.editDialog.initialForm, seq: this.autoIncrementNum.getNextNum(), bankList: [] }
        const defaultEmailSendTo = LocalStorageUtils.getConfiguration('DEFAULT_EMAIL_SEND_TO')
        const platformEmailSendTo = LocalStorageUtils.getConfiguration('PLATFORM_EMAIL_SEND_TO')
        if (defaultEmailSendTo) {
          this.editDialog.form.defaultEmailSendTo = Number(defaultEmailSendTo)
        }
        if (platformEmailSendTo) {
          this.editDialog.form.platformEmailSendTo = Number(platformEmailSendTo)
        }
        this.editDialog.title = this.$t('common.btn.new')
      } else {
        const nodes = this.gridApi.rowModel.rowsToDisplay
        const cell = this.gridApi.getFocusedCell()
        const node = cell ? nodes[cell.rowIndex] : null
        if (!node) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...node.data }
        this.editDialog.title = this.$t('common.btn.edit')
      }
      this.editDialog.visible = true
    },
    onDefaultChange() {
      const form = this.editDialog.form
      if (form.defaultTitle) {
        const existItem = this.rowData.find(p => p.defaultTitle && p.uuid !== form.uuid)
        if (existItem) {
          this.$message.warning(this.$t('Partners.alreadyDefaultInvoicingHeader'))
        }
      }
    },
    // 临时保存
    async saveTemporary() {
      this.$refs.depositBankAccount.hanldeFormat()
      const form = this.editDialog.form
      // if (!form.uuid) {
      //   const index = this.rowData.findIndex(p => p.seq === form.seq)
      //   if (index < 0) {
      //     // 列表没有默认抬头，将数据改为默认抬头
      //     const existItem = this.rowData.find(p => p.defaultTitle)
      //     if (!existItem) {
      //       form.defaultTitle = true
      //     }
      //   }
      // }
      // 若该数据被设为默认，且列表已有默认，将已有默认数据改为非默认
      if (form.defaultTitle) {
        const existItems = this.rowData.filter(p => p.defaultTitle && p !== form)
        if (existItems.length > 0) {
          for (const existItem of existItems) {
            existItem.defaultTitle = false
          }
        }
      }
      const oldRow = this.rowData.find(p => p.seq === form.seq)
      if (oldRow) {
        Object.assign(oldRow, form)
        this.gridApi.refreshCells({ force: true })
        this.gridApi.resetRowHeights()
      } else {
        LocalStorageUtils.setConfiguration('DEFAULT_EMAIL_SEND_TO', this.editDialog.form.defaultEmailSendTo)
        LocalStorageUtils.setConfiguration('PLATFORM_EMAIL_SEND_TO', this.editDialog.form.platformEmailSendTo)
        form.dateModified = new Date()
        this.rowData.push(form)
      }
      // 按最后修改时间倒序排序
      this.rowData.sort((a, b) => {
        const timeA = a.dateModified ? new Date(a.dateModified).getTime() : 0
        const timeB = b.dateModified ? new Date(b.dateModified).getTime() : 0
        return timeB - timeA
      })
      this.editDialog.visible = false
    },
    remove() {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      const cell = this.gridApi.getFocusedCell()
      const node = cell ? nodes[cell.rowIndex] : null
      if (!node) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const row = node.data
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        // 若删除的是默认，将剩余数据中的一条改为默认
        if (row.defaultTitle) {
          const existItem = this.rowData.find(p => p.seq !== row.seq)
          if (existItem) {
            existItem.defaultTitle = true
          }
        }
        const index = this.rowData.findIndex(p => p.seq === row.seq)
        this.rowData.splice(index, 1)
        if (row.uuid) {
          this.deletedTitleKeys.push(row.uuid)
        }
      }).catch(() => { })
    },
    bankManage(seq) {
      const row = this.rowData.find(p => p.seq === seq)
      if (!row) {
        return
      }
      this.bankDialog.title = row
      this.bankDialog.visible = true
    },
    initEditDialogForm() {
      return {
        uuid: '',
        title: '',
        taxAccount: '',
        address: '',
        telephone: '',
        defaultTitle: false,
        email: '',
        autoSend: false,
        customerUuid: '',
        invoiceType: '',
        invoiceMakeType: '',
        defaultEmailSendTo: 0,
        oversea: '',
        financeCode: ''
      }
    },
    // 修改【发票种类】联动修改【发票类型】逻辑不要了，改成了修改【发票类型】联动修改【发票种类】
    // invoiceTypeChange() {
    //   if (this.editDialog.form.invoiceType === InvoiceConstant.BILLING_INVOICE_TYPE_INTERNAL.code &&
    //   this.editDialog.form.invoiceMakeType !== InvoiceConstant.BILLING_INVOICE_CATEGORY_PAPER_INVOICE.code) {
    //     this.editDialog.form.invoiceMakeType = ''
    //   }
    // },
    invoiceMakeTypeChangeHandler() {
      this.invoiceTypes = InvoiceConstant.BILLING_INVOICE_TYPES_EI
      if (this.editDialog.form.invoiceMakeType === InvoiceConstant.BILLING_INVOICE_CATEGORY_PAPER_INVOICE.code) {
        this.invoiceTypes = InvoiceConstant.BILLING_INVOICE_TYPES
        if (this.editDialog.form.invoiceType && (this.editDialog.form.invoiceType === InvoiceConstant.BILLING_INVOICE_TYPE_EI_VAT_DEDICATED.code || this.editDialog.form.invoiceType === InvoiceConstant.BILLING_INVOICE_TYPE_EI_VAT.code)) {
          // 发票种类选了纸质发票，且发票类型是电子发票（增值税专用发票）或电子发票（普通发票），发票类型改为不选
          this.editDialog.form.invoiceType = ''
        }
      }
    },
    emailSendToLabel(value) {
      const data = CompanyConstants.EMAIL_SEND_OBJS.filter(item => item.code === value)
      if (!data || data.length === 0) {
        return ''
      }
      return this.isZh ? data[0].chineseName : data[0].englishName
    },
    // ---- 税率-发票类型配置 相关方法 ----
    // 列表显示：优先使用后端返回的name，fallback按code转换
    getTaxRateLabel(row) {
      if (row && row.taxRateName) {
        return row.taxRateName
      }
      const item = this.taxRateOptions.find(o => String(o.value) === String(row ? row.taxRate : ''))
      return item ? item.label : ''
    },
    getInvoiceTypeLabel(row) {
      if (row && row.invoiceTypeName) {
        return row.invoiceTypeName
      }
      const item = this.taxInvoiceTypeOptions.find(o => String(o.value) === String(row ? row.invoiceType : ''))
      return item ? item.label : ''
    },
    // 选择税率时同步name
    taxRateChangeHandler(value) {
      const item = this.taxRateOptions.find(o => String(o.value) === String(value))
      this.taxInvoiceEditDialog.form.taxRateName = item ? item.label : ''
    },
    // 选择发票类型时同步name
    invoiceTypeChangeHandler(value) {
      const item = this.taxInvoiceTypeOptions.find(o => String(o.value) === String(value))
      this.taxInvoiceEditDialog.form.invoiceTypeName = item ? item.label : ''
    },
    showTaxInvoiceDialog(isNew) {
      if (isNew) {
        this.taxInvoiceEditDialog.form = {
          seq: this.autoIncrementNum.getNextNum(),
          uuid: '',
          taxRate: '',
          taxRateName: '',
          invoiceType: String(InvoiceConstant.INVOICE_TYPE_VAT_FEI.code),
          invoiceTypeName: this.isZh ? InvoiceConstant.INVOICE_TYPE_VAT_FEI.chineseName : InvoiceConstant.INVOICE_TYPE_VAT_FEI.englishName
        }
        this.taxInvoiceEditDialog.title = this.$t('common.btn.new')
      } else {
        if (!this.taxInvoiceCurrentRow) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.taxInvoiceEditDialog.form = { ...this.taxInvoiceCurrentRow }
        this.taxInvoiceEditDialog.title = this.$t('common.btn.edit')
      }
      this.taxInvoiceEditDialog.visible = true
    },
    saveTaxInvoice() {
      const form = this.taxInvoiceEditDialog.form
      if (!form.taxRate) {
        this.$message.warning(this.isZh ? '请选择税率' : 'Please select tax rate')
        return
      }
      if (!form.invoiceType) {
        this.$message.warning(this.isZh ? '请选择发票类型' : 'Please select invoice type')
        return
      }
      // 校验税率不能重复
      const dupIndex = this.taxInvoiceList.findIndex(item => String(item.taxRate) === String(form.taxRate) && item.seq !== form.seq)
      if (dupIndex >= 0) {
        this.$message.warning(this.isZh ? '税率已存在，不可重复配置' : 'Duplicate tax rate configuration')
        return
      }
      const idx = this.taxInvoiceList.findIndex(item => item.seq === form.seq)
      if (idx >= 0) {
        this.taxInvoiceList.splice(idx, 1, { ...form })
      } else {
        this.taxInvoiceList.push({ ...form })
      }
      this.taxInvoiceEditDialog.visible = false
    },
    removeTaxInvoice() {
      if (!this.taxInvoiceCurrentRow) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const row = this.taxInvoiceCurrentRow
        const index = this.taxInvoiceList.findIndex(item => item.uuid === row.uuid)
        if (index >= 0) {
          this.taxInvoiceList.splice(index, 1)
        }
        if (row.uuid) {
          this.deletedTaxInvoiceKeys.push(row.uuid)
        }
        this.taxInvoiceCurrentRow = null
      }).catch(() => {})
    },
    getSelectedRow() {
      const nodes = this.gridApi.rowModel.rowsToDisplay
      const cell = this.gridApi.getFocusedCell()
      const node = cell ? nodes[cell.rowIndex] : null
      return node ? node.data : null
    },
    // 推送新增客商
    pushAddCustomer() {
      const row = this.getSelectedRow()
      if (!row) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      // const title = { ...row }
      // if (title.financeCode) {
      //   this.$message.warning(this.$t('CargoMsg.Cargo_ExistFinanceCode'))
      //   return
      // }
      this.pushAddCustomerDialog.areaCode = SystemConstants.U8C_AREA_01.code
      this.pushAddCustomerDialog.visible = true
    },
    // 确定推送
    confirmPush() {
      const loading = getLoading4Cxt(this)
      const row = this.getSelectedRow()
      if (!row || !row.uuid) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        loading.close()
        return
      }
      syncTitleToYYU8({ anyStr: row.uuid, anyStr1: this.pushAddCustomerDialog.areaCode, branchId: this.$store.getters.currentOfficeId }).then(res => {
        loading.close()
        const result = res.data
        if (result) {
          if (result.success) {
            this.$message.success(this.$t('CargoMsg.Cargo_CreatedSuccessful'))
          } else {
            this.$message.error(result.msg)
          }
          this.pushAddCustomerDialog.visible = false
        }
      }).catch(() => {
        loading.close()
      })
    }
  }
}
</script>

<style>
</style>
